export default __webpack_public_path__ + "static/media/ic-en.52e62014.svg";